import React from 'react';
import { trackFbEvent } from '../utils/fbpixel';
const tomos = [{
  icon: '📘',
  num: 'TOMO 1',
  title: 'El Código del Biofilm',
  desc: 'Por qué fallaste antes y qué cambia ahora',
  value: '$12.000'
}, {
  icon: '📗',
  num: 'TOMO 2',
  title: 'Fase de Choque 72 Horas',
  desc: 'Alivio inmediato sin químicos agresivos',
  value: '$12.000'
}, {
  icon: '📙',
  num: 'TOMO 3',
  title: 'Nutrición Anti-Fúngica AR',
  desc: 'Qué comprar en Coto/Carrefour/Jumbo',
  value: '$10.000'
}, {
  icon: '📕',
  num: 'TOMO 4',
  title: 'El Eje Intestino-Vagina',
  desc: 'Cortar la fuente de re-infección de raíz',
  value: '$12.000'
}, {
  icon: '📓',
  num: 'TOMO 5',
  title: 'Suplementación Estratégica',
  desc: 'Los 5 antifúngicos naturales más potentes',
  value: '$10.000'
}, {
  icon: '📔',
  num: 'TOMO 6',
  title: 'Blindaje y Recidivas',
  desc: 'Que no vuelva nunca más',
  value: '$10.000'
}];
const bonuses = [{
  icon: '🌙',
  num: 'BONUS 1',
  title: 'Guía de Rescate Nocturno',
  desc: 'Alivio en 15 min cuando el ardor no te deja dormir',
  value: '$8.000'
}, {
  icon: '🍳',
  num: 'BONUS 2',
  title: 'Recetario Sin Dulce',
  desc: '20 recetas ricas que matan al hongo con ingredientes de tu super',
  value: '$8.000'
}, {
  icon: '🧴',
  num: 'BONUS 3',
  title: 'Auditoría de Baño',
  desc: 'Los productos que destruyen tu pH todos los días sin que lo sepas',
  value: '$7.000'
}];
export function ProductSection() {
  return <section className="w-full px-6 py-16 max-w-2xl mx-auto" data-id="element-185">
      <p className="text-brand-magenta text-[11px] font-semibold uppercase tracking-widest mb-3" data-id="element-186">
        Todo lo que recibís hoy
      </p>
      <h2 className="text-[24px] font-bold text-white mb-3 leading-tight" data-id="element-187">
        No es un libro. Es un sistema de 9 piezas.
      </h2>

      <a href="#compra" onClick={() => trackFbEvent('InitiateCheckout', {
      content_name: 'Product CTA',
      value: 19990,
      currency: 'ARS'
    })} className="w-full max-w-sm mx-auto block bg-brand-magenta hover:brightness-110 text-white font-bold text-[15px] rounded-xl py-3.5 text-center transition-all animate-pulse-slow shadow-lg shadow-brand-magenta/30 mb-8" data-id="element-188">
        🔓 QUIERO EL MÉTODO pH-ZERO
        <span className="block text-xs font-normal mt-0.5 opacity-90" data-id="element-189">
          Acceso Inmediato
        </span>
      </a>

      <div className="flex flex-col mb-10" data-id="element-190">
        {tomos.map((tomo, i) => <div key={i} className="flex items-start justify-between py-4 border-b border-white/[0.08]" data-id="element-191">
            <div className="flex-1" data-id="element-192">
              <p className="text-white font-semibold text-[15px]" data-id="element-193">
                {tomo.icon} {tomo.num} · {tomo.title}
              </p>
              <p className="text-brand-muted text-sm mt-0.5" data-id="element-194">{tomo.desc}</p>
            </div>
            <p className="text-brand-muted text-sm ml-4 whitespace-nowrap" data-id="element-195">
              Valor {tomo.value}
            </p>
          </div>)}
      </div>

      <div className="h-px w-full mb-10" style={{
      background: 'linear-gradient(to right, #FF006E, #00F5D4)'
    }} data-id="element-196" />

      <div data-id="element-197">
        <h3 className="text-[20px] font-bold text-brand-teal mb-2" data-id="element-198">
          🎁 MÁS TUS 3 BONUS EXCLUSIVOS
        </h3>
        <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-brand-teal/10 border border-brand-teal/40 mb-6" data-id="element-199">
          <span className="text-brand-teal text-sm font-bold" data-id="element-200">
            🎉 ¡GRATIS por el día de hoy!
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-4 mb-10" data-id="element-201">
        {bonuses.map((bonus, i) => <a key={i} href="#compra" className="block" data-id="element-202">
            <div className="bg-white/[0.04] rounded-2xl overflow-hidden border border-brand-teal/20 hover:border-brand-teal/40 transition-colors" data-id="element-203">
              <div className="w-full h-28 bg-gradient-to-r from-[#1A0A2E] to-[#0D0D0D] flex items-center justify-center relative" data-id="element-204">
                <span className="text-4xl" data-id="element-205">{bonus.icon}</span>
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-brand-teal/20 text-brand-teal text-[10px] font-bold" data-id="element-206">
                  GRATIS HOY
                </div>
              </div>
              <div className="p-4 flex items-start justify-between" data-id="element-207">
                <div className="flex-1" data-id="element-208">
                  <p className="text-white font-semibold text-[15px]" data-id="element-209">
                    {bonus.num} · {bonus.title}
                  </p>
                  <p className="text-brand-muted text-sm mt-0.5" data-id="element-210">
                    {bonus.desc}
                  </p>
                </div>
                <p className="text-brand-muted text-sm ml-4 whitespace-nowrap line-through" data-id="element-211">
                  Valor {bonus.value}
                </p>
              </div>
            </div>
          </a>)}
      </div>

      <a href="#compra" className="block" data-id="element-212">
        <div className="rounded-2xl p-6 text-center" style={{
        background: 'linear-gradient(135deg, rgba(255,0,110,0.2) 0%, rgba(255,0,110,0.05) 100%)',
        border: '1px solid rgba(255,0,110,0.3)'
      }} data-id="element-213">
          <p className="text-brand-muted text-sm font-semibold uppercase tracking-wider mb-2" data-id="element-214">
            Valor total del sistema
          </p>
          <p className="text-white/60 text-2xl font-bold line-through mb-4" data-id="element-215">
            $89.000
          </p>
          <p className="text-brand-muted text-sm font-semibold uppercase tracking-wider mb-2" data-id="element-216">
            Tu inversión hoy
          </p>
          <p className="text-brand-magenta text-4xl font-bold mb-3" data-id="element-217">$19.990</p>
          <div className="h-px w-32 mx-auto bg-brand-magenta/40 mb-3" data-id="element-218" />
          <p className="text-brand-muted text-sm leading-relaxed" data-id="element-219">
            Menos que una consulta privada
            <br data-id="element-220" />+ una caja de óvulos que no funciona
          </p>
        </div>
      </a>
    </section>;
}